import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import history from "../Routes/history";
import LoadingOverlay from "../LoadingOverlay";
import EmailTagInput from './EmailTagInput';

const MailParams = ({ sender, password, to, cc, cci, subject, text, title, filename, disableButton, handleChange, handleOpenDialog, showPDF }) => {
    const [showPassword, setShowPassword] = useState(false);
    const { attachment, typeFile } = useSelector(state => ({
        attachment: state.email.file,
        typeFile: state.email.typefile
    }));

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    const handleGoBack = () => {
        history.push(
            title === "VIC" ? "/vic/page-1" :
                title === "Registre Journal" ? "/rj/evaluation" :
                    title === "Contrat" ? "/contrat/données" :
                        title === "Avenant Echéances" ? "/contrat/echeances" :
                            title === "PGC" ? "/pgc/page1" :
                                title === "Pré DIUO" ? "/prediuo/page1" :
                                    title === "DIUO" ? "/diuo/page1" :
                                        title === "Proposition de Devis" ? "/devis/proposition" :
                                            title === "Calcul Approximatif" ? "/devis/calcul" :
                                                title.includes("Facture Conception") ? "/facture/conception" :
                                                    title.includes("Facture Réalisation") ? "/facture/realisation" :
                                                        title.includes("Facture Récapitulative") ? "/facture/recapitulative" :
                                                            "/dashboard"
        );
    };

    const isFormValid = title && filename && to && sender && password && !disableButton;

    return (
        <div className="mail-params">
            <div className="mail-params__form">
                <div className="mail-params__row">
                    <div className="mail-params__field">
                        <label className="mail-params__label">Expéditeur *</label>
                        <input
                            type="email"
                            name="sender"
                            value={sender}
                            onChange={handleChange}
                            className="mail-params__input"
                            placeholder="votre.email@example.com"
                            required
                            disabled={disableButton}
                        />
                    </div>

                    <div className="mail-params__field">
                        <label className="mail-params__label">Mot de passe *</label>
                        <div className="mail-params__password-container">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                value={password}
                                onChange={handleChange}
                                className="mail-params__input"
                                placeholder="Votre mot de passe"
                                required
                                disabled={disableButton}
                            />
                            <button
                                type="button"
                                className="mail-params__password-toggle"
                                onClick={togglePasswordVisibility}
                                aria-label="Afficher/masquer le mot de passe"
                                disabled={disableButton}
                            >
                                {showPassword ? (
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                        <line x1="1" y1="1" x2="23" y2="23" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                <EmailTagInput
                    name="to"
                    value={to}
                    onChange={handleChange}
                    placeholder="destinataire@example.com"
                    label="Destinataire"
                    required={true}
                    disabled={disableButton}
                />

                <EmailTagInput
                    name="cc"
                    value={cc}
                    onChange={handleChange}
                    placeholder="copie@example.com"
                    label="Cc"
                    disabled={disableButton}
                />

                <EmailTagInput
                    name="cci"
                    value={cci}
                    onChange={handleChange}
                    placeholder="copie.cachee@example.com"
                    label="Cci"
                    disabled={disableButton}
                />

                <div className="mail-params__field">
                    <label className="mail-params__label">Objet</label>
                    <input
                        type="text"
                        name="subject"
                        value={subject}
                        onChange={handleChange}
                        className="mail-params__input"
                        placeholder="Objet du message"
                        disabled={disableButton}
                    />
                </div>

                <div className="mail-params__field">
                    <label className="mail-params__label">Message</label>
                    <textarea
                        name="text"
                        value={text}
                        onChange={handleChange}
                        className="mail-params__textarea"
                        placeholder="Votre message..."
                        rows={8}
                        disabled={disableButton}
                    />
                </div>

                <div className="mail-params__footer">
                    <div className="mail-params__field mail-params__field--file">
                        <label className="mail-params__label">Nom du fichier à envoyer *</label>
                        <div className="mail-params__file-container">
                            <input
                                type="text"
                                name="filename"
                                value={filename}
                                onChange={handleChange}
                                className="mail-params__input"
                                placeholder="nom_du_fichier.pdf"
                                style={{ padding: "0.7rem 30px 0.7rem 0.7rem" }}
                                required
                                disabled={disableButton}
                            />
                            {attachment && (
                                <div className="mail-params__file-indicator">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                                        <polyline points="14,2 14,8 20,8" />
                                        <line x1="16" y1="13" x2="8" y2="13" />
                                        <line x1="16" y1="17" x2="8" y2="17" />
                                        <polyline points="10,9 9,9 8,9" />
                                    </svg>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="mail-params__actions">
                        {disableButton && <LoadingOverlay />}

                        <button
                            type="button"
                            className={`mail-params__btn mail-params__btn--primary ${!isFormValid ? 'mail-params__btn--disabled' : ''}`}
                            onClick={handleOpenDialog}
                            disabled={!isFormValid}
                        >
                            Envoyer
                        </button>

                        <button
                            type="button"
                            className={`mail-params__btn mail-params__btn--secondary ${(typeFile !== "Pdf" || disableButton) ? 'mail-params__btn--disabled' : ''}`}
                            onClick={showPDF}
                            style={{ padding: '12px' }}
                            disabled={typeFile !== "Pdf" || disableButton}
                        >
                            Afficher
                        </button>

                        <button
                            type="button"
                            className="mail-params__btn mail-params__btn--secondary"
                            onClick={handleGoBack}
                            style={{ padding: '12px' }}
                            disabled={disableButton}
                        >
                            Retour
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MailParams;